/* ═══════════════════════════════════════════════════════════════════════════
   flats-plans-view.js — вкладка «Планировки» витрины квартир ОДНОГО дома
   (27.09.2026). Слово владельца: «нам нужно только поменять местами: блок
   планировки верхний добавить в нижний, а нижний старый блок планировки убрать».

   Что делает. Переключатель витрины «Сводка · Плитка · Список · Планировки»
   остаётся прежним, вид по умолчанию — тоже (плитка). «Планировки» теперь — ТОТ ЖЕ
   блок, что на карточке ЖК и странице комнатности: карточки планировок, окно
   планировки (js/plan-modal.js), панель её квартир, «Посмотреть на генплане» /
   «Вернуться к планировке». Второй разметки и второго скрипта нет: блок —
   снимок карточки, его рисуют js/jk-filter.js и js/jk-filter-results.js.

   ⛔ БЛОК ПРИХОДИТ ПО ЗАПРОСУ, А НЕ ЛЕЖИТ В РАЗМЕТКЕ. Под неоткрытой вкладкой он был
   бы спрятанным текстом (таблица типов с ценами, подписи фильтра), поэтому HTML
   витрины прежний байт в байт. Вкладку открыли — просим кусок того же адреса
   `?part=plans` (public/flats.php, \BroniDom\Seo\ShowcasePlansPart), ставим его на
   место сетки и подключаем стили и скрипты, которые кусок назвал сам. Второй раз —
   без сети: блок уже на месте.

   ⛔ ФИЛЬТР ОДИН — ВИТРИНЫ. Набор фильтров и сортировку отдаёт js/flats.js (тот же,
   с которым он только что просил плитку); блок у себя их только применяет (`drive`
   в js/jk-filter.js), его собственный пульт на экран не выводится. «Найдено» пишем
   в строку итога витрины — `#flatsCount` и событие для js/flats-showcase.js.

   Контракт (window.BroniFlatsPlans; потребитель — js/flats.js):
     show(filters, sort) — открыть вкладку с этим набором (повторный вызов — сменить
                           набор). Класс `flats-jk-plans-on` на <body>: стиль прячет
                           сетку, ряд страниц и «Показать ещё» и показывает вкладку
                           (css/flats-showcase.css) — выдача плитки не стирается;
     hide()              — вкладку закрыли: класс снят, сетка на месте.
   Сбой (сеть, 5xx, битый ответ, ожидание дольше PART_TIMEOUT_MS) — строка «Не удалось
   загрузить планировки» и «Повторить»; плитка и остальная страница целы. Ответ 204 —
   не сбой, а «блока нет» (дом распродан): «В этом доме сейчас нет планировок в продаже»,
   без «Повторить» — повтор не поможет.

   ⛔ МЕСТО СЕТКИ ДЕРЖИМ, ПОКА ГРУЗИТСЯ БЛОК (доводка-3, 27.09.2026, P1-1 проверяющего).
   Без этого сетка по нажатию исчезала сразу, раздел ниже («Быстрый поиск», подвал)
   подскакивал на экран, а через 1,6–5,9 с блок уталкивал его обратно — сдвиг вёрстки
   0,36–0,48 на телефоне и планшете (первый прыжок браузер прощает как ответ на нажатие,
   второй — нет). Теперь по нажатию узел вкладки занимает ровно высоту ушедшей сетки
   (`hold`, в том же кадре — ничто ниже не двигается), а когда блок нарисован, сбой или
   «нет планировок» — отпускает её так, чтобы то, что было ниже края экрана, там и осталось
   (`settle`): короткий блок держит пустоту до края экрана, длинный — свою высоту. Пустота
   уходит сама, как только её снятие никого не сдвинет на экране (низ блока ушёл за нижний
   край окна при прокрутке), или по вводу человека.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
    'use strict';
    if (window.BroniFlatsPlans) return;
    const grid = document.getElementById('flatsGrid');
    const BUILDING = String(window.BRONI_FLATS_BUILDING_ID || '');
    if (!grid || BUILDING === '') return;

    const PART = '?part=plans';
    // Предел ожидания куска и каждого скрипта блока (P2-2 проверяющего): зависший запрос
    // иначе держал бы «Загружаем планировки…» навсегда, без «Повторить».
    const PART_TIMEOUT_MS = 12000;
    let host = null;
    let note = null;
    let stage = 'idle';      // idle | loading | ready | failed | empty
    let want = { query: {}, sort: '' };
    let api = null;
    let open = false;
    let settled = false;        // запасённое место под сетку уже отпущено
    const loaded = new Set();   // скрипты блока, уже исполненные (повтор после сбоя их не зовёт)

    function el(tag, cls, text) {
        const node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    /** Место вкладки — там же, где сетка: сразу перед ней, в контейнере карточек. */
    function ensureHost() {
        if (host) return host;
        host = el('div', 'flats-plans-view');
        host.id = 'flatsPlansView';
        grid.parentNode.insertBefore(host, grid);
        return host;
    }

    /** Строка состояния вкладки (загрузка / сбой). Текст — только textContent. */
    function setNote(text, retry) {
        if (!note) {
            note = el('div', 'flats-plans-view__note');
            note.setAttribute('role', 'status');
            ensureHost().insertBefore(note, host.firstChild);
        }
        note.textContent = text;
        if (retry) {
            const btn = el('button', 'flats-plans-view__retry', 'Повторить');
            btn.type = 'button';
            btn.addEventListener('click', () => load());
            note.appendChild(btn);
        }
        note.hidden = false;
    }

    function clearNote() {
        if (note) note.hidden = true;
    }

    /**
     * Место ушедшей сетки — узлу вкладки, в том же кадре, что и прячется сетка. Высота
     * контейнера карточек до и после смены класса — ровно столько, сколько надо вернуть:
     * вместе с сеткой уходят ряд страниц, «Показать ещё» и отступ вкладки.
     */
    function hold() {
        host.style.minHeight = '';
        const box = grid.parentNode;
        const before = box.getBoundingClientRect().height;
        document.body.classList.add('flats-jk-plans-on');
        const lost = before - box.getBoundingClientRect().height;
        if (lost > 0) host.style.minHeight = Math.ceil(host.getBoundingClientRect().height + lost) + 'px';
    }

    /**
     * Блок нарисован, сбой или «нет планировок» — место отпускаем, но так, чтобы то, что
     * стояло ниже края экрана, ниже и осталось: короткий узел держит высоту до края окна,
     * длинный — свою. Прыжок снизу вверх на экран — тот самый сдвиг, который браузер
     * засчитывает (ответ пришёл позже 0,5 с после нажатия).
     */
    function settle() {
        if (!host) return;
        host.style.minHeight = '';
        const box = host.getBoundingClientRect();
        const floor = Math.ceil((window.innerHeight || 0) - box.top);
        if (box.height < floor) {
            host.style.minHeight = floor + 'px';
            watchRelease();
        }
    }

    /**
     * Остаток запаса (пустота под коротким блоком до края окна) уходит сам, как только это
     * никого не сдвинет на экране: низ содержимого вкладки ушёл за нижний край окна (человек
     * прокрутил вверх) — раздел ниже и до, и после снятия остаётся за краем. Проверка — по
     * прокрутке, без чтения стилей: низ содержимого — низ детей узла.
     */
    let watching = false;
    function contentBottom() {
        let bottom = host.getBoundingClientRect().top;
        Array.prototype.forEach.call(host.children, (child) => {
            if (child.hidden) return;
            const r = child.getBoundingClientRect();
            if (r.height > 0) bottom = Math.max(bottom, r.bottom);
        });
        return bottom;
    }
    function stopWatch() {
        if (!watching) return;
        watching = false;
        window.removeEventListener('scroll', releaseIfSafe);
    }
    function releaseIfSafe() {
        if (!host || !host.style.minHeight) {
            stopWatch();
            return;
        }
        if (contentBottom() >= (window.innerHeight || 0)) {
            host.style.minHeight = '';
            stopWatch();
        }
    }
    function watchRelease() {
        if (watching) return;
        watching = true;
        window.addEventListener('scroll', releaseIfSafe, { passive: true });
    }

    /** Всё запасённое место — прочь: человек сам что-то нажал (сдвиг в ответ на ввод). */
    function unhold() {
        stopWatch();
        if (host) host.style.minHeight = '';
    }

    /** Обещание с пределом ожидания: не успело — отказ, как у сбоя. */
    function within(promise, ms, onTimeout) {
        return new Promise((resolve, reject) => {
            const timer = window.setTimeout(() => {
                if (typeof onTimeout === 'function') onTimeout();
                reject(new Error('timeout'));
            }, ms);
            promise.then((v) => { window.clearTimeout(timer); resolve(v); },
                (e) => { window.clearTimeout(timer); reject(e); });
        });
    }

    /**
     * Стили блока — сразу за flats.css, как у страницы комнатности (каскад тот же). Адрес
     * flats.css называет сам кусок (`data-css-after`): имя файла сборки несёт хэш, и искать
     * его на странице по имени было бы угадыванием. Не нашёлся — в конец <head>.
     */
    function loadStyles(urls, after) {
        let at = null;
        document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
            if (after && link.getAttribute('href') === after) at = link;
        });
        urls.forEach((url) => {
            if (document.querySelector('link[rel="stylesheet"][href="' + url + '"]')) return;
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            if (at && at.parentNode) {
                at.parentNode.insertBefore(link, at.nextSibling);
                at = link;
            } else {
                document.head.appendChild(link);
            }
        });
    }

    /** Скрипты блока — по очереди: выдача подписывается на контракт фильтра. */
    function loadScript(url) {
        if (loaded.has(url)) return Promise.resolve();
        return within(new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = false;
            script.addEventListener('load', () => {
                loaded.add(url);
                resolve();
            });
            script.addEventListener('error', () => reject(new Error('script ' + url)));
            document.body.appendChild(script);
        }), PART_TIMEOUT_MS);
    }

    /**
     * Список адресов из атрибута куска: только пути нашего сайта — «/» и не «//» или «/\»
     * (адрес без протокола браузер понял бы как чужой хост; P2-4 проверяющего).
     */
    function urlList(raw) {
        let list = [];
        try {
            list = JSON.parse(raw || '[]');
        } catch (e) {
            list = [];
        }
        return Array.isArray(list) ? list.filter((u) => typeof u === 'string' && /^\/(?![/\\])/.test(u)) : [];
    }

    /** Ответ блока → строка итога витрины («Найдено N планировок · M квартир»). */
    function onPlans(payload) {
        if (!payload || payload.mode !== 'plans') return;
        clearNote();
        if (!open) return;
        // Первые карточки на месте — запасённое место отпускаем (выдача уже нарисована:
        // выдача блока подписана раньше нас).
        if (!settled) {
            settled = true;
            settle();
        }
        const count = document.getElementById('flatsCount');
        if (count) count.textContent = String(payload.total || 0);
        try {
            document.dispatchEvent(new CustomEvent('broni:flats-plans-found', {
                detail: { plans: payload.plans || 0, total: payload.total || 0 },
            }));
        } catch (e) {
            // сообщить некому — число в #flatsCount уже стоит
        }
    }

    /** Дома без планировок в продаже (ответ 204, отказ фасетов): не сбой, повтор не нужен. */
    function empty() {
        stage = 'empty';
        setNote('В этом доме сейчас нет планировок в продаже.', false);
        settle();
    }

    async function load() {
        if (stage === 'loading' || stage === 'ready') return;
        stage = 'loading';
        settled = false;
        setNote('Загружаем планировки…', false);
        try {
            const ctrl = typeof window.AbortController === 'function' ? new window.AbortController() : null;
            const res = await within(
                fetch(window.location.pathname + PART, ctrl ? { credentials: 'same-origin', signal: ctrl.signal } : { credentials: 'same-origin' }),
                PART_TIMEOUT_MS,
                () => { if (ctrl) ctrl.abort(); }
            );
            if (res.status === 204) {
                empty();
                return;
            }
            if (res.status !== 200) throw new Error('HTTP ' + res.status);
            const doc = new window.DOMParser().parseFromString(await res.text(), 'text/html');
            const part = doc.querySelector('.flats-plans-part');
            const section = part && part.querySelector('#jkFlats');
            const filter = section && section.querySelector('#jkFilter[data-on-showcase]');
            if (!filter) throw new Error('bad part');
            // Стартовый набор — атрибутом: первый запрос блока уйдёт сразу с фильтром витрины.
            filter.setAttribute('data-flats-drive', JSON.stringify(want));
            // Прошлая попытка могла оставить блок без скриптов — ставим свежий.
            const stale = ensureHost().querySelector('#jkFlats');
            if (stale) stale.remove();
            host.appendChild(document.importNode(section, true));
            loadStyles(urlList(part.getAttribute('data-css')), part.getAttribute('data-css-after') || '');
            for (const url of urlList(part.getAttribute('data-js'))) {
                await loadScript(url);
            }
            api = window.BroniJkFilter;
            if (!api || typeof api.drive !== 'function') throw new Error('no filter');
            stage = 'ready';
            api.onResults(onPlans);
            let loading = false;
            if (typeof api.onLoading === 'function') api.onLoading((on) => { loading = Boolean(on); });
            // ⛔ Фасеты пришли ПОВТОРОМ после сбоя (5xx): фильтр блока сам выдачу тогда не
            // заводит (находка №8 отчёта 26.09 — так и на карточке ЖК), и вкладка стояла бы на
            // «Загружаем планировки…» до первой смены фильтра витрины. Здесь — только для вкладки:
            // пришли фасеты, а выдачи нет и она не летит — зовём её сами. Ответ, который фильтр
            // отдаёт сразу при подписке (фасеты уже были), — не повтор, его пропускаем; обычный
            // первый приход фасетов фильтр заводит сам, и к нашей проверке запрос уже летит.
            let replay = true;
            api.onFacets((facets) => {
                if (facets === null) {
                    empty();
                    return;
                }
                if (replay) return;
                window.setTimeout(() => {
                    if (!api.lastResult && !loading && typeof api.apply === 'function') api.apply({ page: 1 });
                }, 0);
            });
            replay = false;
            // Набор мог смениться, пока блок ехал.
            api.drive(want.query, want.sort);
        } catch (e) {
            stage = 'failed';
            setNote('Не удалось загрузить планировки.', true);
            settle();
        }
    }

    window.BroniFlatsPlans = {
        show(query, sort) {
            want = { query: query && typeof query === 'object' ? Object.assign({}, query) : {}, sort: String(sort || '') };
            ensureHost();
            // Вкладка уже открыта (сменился фильтр) — это ввод человека: остаток запаса убираем.
            // Открывается — держим место сетки, пока блок не нарисован (кроме готового блока).
            if (open || stage === 'ready' || stage === 'empty') {
                unhold();
                document.body.classList.add('flats-jk-plans-on');
            } else {
                hold();
            }
            open = true;
            if (stage === 'empty') {
                settle();
                return;
            }
            if (stage === 'ready' && api) {
                api.drive(want.query, want.sort);
                const last = api.lastResult;
                if (last) onPlans(last);
                return;
            }
            load();
        },
        hide() {
            open = false;
            unhold();
            document.body.classList.remove('flats-jk-plans-on');
        },
    };
})();
